/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, FC } from "react";
import { useSelector } from "react-redux";

interface PageProps {
    children: any;
    title: any
}

const Page: FC<PageProps> = ({ children, title }) => {
    // const storeInfo = useSelector((state) => state.storeInfo)
    useEffect(() => {
        document.title = `Enabill | ${title}`;
        window.scrollTo(0, 0);
    }, [title]);
    return <div id={title}>{children}</div>;
    
}

export default Page;
